<template>

    <div>
        <!-- <el-form :inline="true" :model="query" class="query-form">
            <el-form-item>
                <el-input v-model="query.name" placeholder="发布人名称"></el-input>
            </el-form-item>
            <el-form-item class="query-form-item" label="时间：" size="mini">
                <span class="demonstration"></span>
                <el-date-picker
                    v-model="query.start_time"
                    type="date"
                    placeholder="开始时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
                -
                <el-date-picker
                    v-model="query.end_time"
                    type="date"
                    placeholder="结束时间"
                    value-format="yyyy-MM-dd 23:59:59"
                    format="yyyy-MM-dd 23:59:59">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary"  icon="el-icon-search" @click.native="onSubmit(1)">查询</el-button>
                    <el-button type="primary"  icon="el-icon-refresh" @click="onSubmit(2)">重置</el-button>
                </el-button-group>
            </el-form-item>
        </el-form> -->  
         <el-form :inline="true" :model="query" class="query-form" size="mini">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click.native="handleForm(null,null,'add')" style="float:left;  margin-right: 50px; margin-bottom: 10px;">新增</el-button>
        </el-form>
        <el-table
            text-align="center"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            v-loading="loading"
            ref="multipleTable"
            :data="data"
            style="width: 100%;"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}">
            <!-- <el-table-column type="selection" width="55" fixed> </el-table-column> -->
            <!-- <el-table-column
                label="封面"
                prop="image"
                fixed>
                <template slot-scope="scope">            
                    <img :src="scope.row.image"  min-width="70" height="70" />
                </template> 
            </el-table-column> -->
            <el-table-column align="center" label="编号" prop="cate_id"> </el-table-column>
            <el-table-column align="center" label="名称" prop="dz_name"> </el-table-column>
            <el-table-column align="center" label="关联Tag" prop="cate_name"> </el-table-column>
            <el-table-column align="center" label="口令" prop="dz_code"> </el-table-column>
            <el-table-column align="center" label="添加时间" prop="time"></el-table-column>
            <el-table-column align="center" label="是否启用 否/是" >
                <template slot-scope="scope">
                    <el-switch
                    v-model="scope.row.is_dz_status"
                    active-color="#00A854"
                    @change="changeSwitch(scope.$index,scope.row.cate_id, scope.row.is_dz_status)"
                    inactive-color="red"
                    :active-value="1"
                    :inactive-value="2"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="操作"
                fixed="right">
                <template  slot-scope="scope">
                    <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row.cate_id,'upd')">编辑</el-button>
                        <!-- <el-switch
                        v-model="scope.row.is_use"
                        active-color="#00A854"
                        @change="changeSwitch(scope.$index,scope.row.cate_id, scope.row.is_use)"
                        inactive-color="#DCDFE6"
                        :active-value="1"
                        :inactive-value="2"
                        ></el-switch> -->
                    <!-- <el-button type="text" size="small" @click.native="handleFormStop(scope.$index, scope.row.cate_id)">停用</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination-container"
            style="height:50px;"
            background
            :page-size="page_size"            
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total"
            :current-page.sync="query.page">
        </el-pagination>

    </div>

</template>

<script>
import { dzTagList, openScreenStop } from "../../api/category/category";
export default {
    data() {
        return {
            loading: true,
            searchUsersType: "id",
            total: 0,
            page_size: 10,
            currentPage: 1,
            query: {
                page:'1',
                find_id: ''
            },
            data: [],
            multipleSelection:[],
            switchData: [],
        };
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            sessionStorage.setItem( "currentPage_findList", val);
            // scrollTo(0, 800);
            this.getData();
        },
        getData() {
            dzTagList(this.query).then(response => {
                this.data = response.data.data || [];
                this.loading = false;
                this.total = response.data.total;
            }).catch(() => {
                this.loading = false;
                this.data = [];
                this.total = 0;
            });
        },
        onSubmit(type) {
            // this.query.page = 1;
            if (type == 1) {
                this.getData();
            }
            if (type == 2) {
                this.currentPage = 1;
                this.query = {
                    page: 1,
                    id: "",
                    mobile: "",
                    name: "",
                    token: 1111,
                    user_id: 1,
                    limit: 10,
                    start_time: "",
                    end_time: "",
                    status:1,
                    user_type:2,
                    find_type:3
                };
                this.getData();
            }
        },
        // 开关操作
        changeSwitch (index,cate_id,is_sign) {
            this.switchData = {'cate_id':cate_id,'is_use':is_sign};
            openScreenStop(this.switchData)
                .then(response => {
                    console.log(response,'444444444444444');
                    if (response.code != 0) {
                        this.$message.error(response.msg);
                        return false;
                    } else {
                        this.$message.success("操作成功");
                        this.getData();
                        // if (response.data.is_dz_status == 1) {
                        //     this.$message.success("已启用");
                        //     this.getData();
                        // } else {
                        //     this.$message.success("已停用");
                        //     this.getData();
                        // }
                    }
                })
                .catch(() => {
                    this.deleteLoading = false;
                });
        },
        handleFormStop(index, row) {
            if (row) {
                this.$confirm("确认恢复该记录吗?", "提示", {
                    type: "warning"
                })
                .then(() => {
                    let para = { find_id: row };
                    this.deleteLoading = true;
                    recycleRecovery(para)
                        .then(response => {
                            this.deleteLoading = false;
                            if (response.code != 0) {
                                this.$message.error(response.msg);
                                return false;
                            } else {
                                this.$message.success("恢复成功");
                                this.data.splice(index, 1);
                                this.getData();
                            }
                        })
                        .catch(() => {
                            this.deleteLoading = false;
                        });
                })
                .catch(() => {
                    this.$message.info("取消删除");
                });
            }
        },
        // 审核
        handleCheck(index,row, status) {
            if (row) {
                var tishi = '';
                if(status == 2) {
                    tishi = '拒绝';
                } else {
                    tishi = '通过';
                }
                this.$confirm("确认" + tishi +"该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let para = { find_id: row , status:status};
                        this.deleteLoading = true;
                        findCheck(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code != 200) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success(tishi+"成功");
                                // 刷新数据
                                // this.data.splice(index, 1);
                                this.getData();
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
            }
        },
        handleForm(index,row,use) {
            // console.log(index,'-----------',row,'-----------------',use)
            if (use == 'add') {
                this.$router.push({ path: '/openScreen/openScreenAdd/cate_id/0' })
            }
            // 修改
            if (use == 'upd') {
                this.$router.push({ path: '/openScreen/openScreenAdd/cate_id/'+row })
            }
            // this.$router.push({
            //     path: "/openScreen/openScreenAdd",
            //     query: {
            //         cate_id: row,
            //         type: use
            //     }
            // });
        },
        // 显示表单
        handleForm2(index,row) {
            this.$router.push({
                path: "/openScree/openScreenAdd",
                query: {
                    find_id: row
                }
            });
        }
    },
    filters: {
        ellipsis (value) {
            if (!value) return ''
            if (value.length > 18) {
                return value.slice(0,18) + '...'
            }
            return value
        },
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                1: "普通用户",
                2: "医生",
                3: "咨询师",
                4: "医院",
                5: "未确定"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        sessionStorage.setItem( "currentPage_advertList", 1);
        sessionStorage.setItem( "currentPage_findVideoList", 1);
        sessionStorage.setItem( "currentPage_findList", 1);
        sessionStorage.setItem( "currentPage_messageList", 1);
        sessionStorage.setItem( "currentPage_normalUsersAdmin", 1);
        sessionStorage.setItem( "currentPage_userList", 1);
        sessionStorage.setItem( "currentPage_editorList", 1);
        this.query.page = 1
        // this.query.page = Number(sessionStorage.getItem("currentPage_findList")) || 1;
        this.getData();
    }
};
</script>
<style type="text/scss" lang="scss">
</style>
<style>
 .el-form-item__label{
     margin-top: 5px;
 }
</style>
